import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/_Pages/NewProperties/index.tsx");
